import { faker } from '@faker-js/faker'
import { Factory } from 'miragejs'
import { format, subYears, addYears, isAfter } from 'date-fns'

export default Factory.extend({
  softCapacity() {
    const exact = faker.number.int({ min: 100, max: 300 })
    const rounded = exact - (exact % 10)
    return `${rounded}`
  },
  // The backend provides date as yyyy-MM-dd date (technically ISO8601 shorthand), so this is what the factory prodivdes
  startDate() {
    const past = subYears(new Date(), 1)
    return format(past, 'yyyy-MM-dd')
  },
  endDate() {
    const future = addYears(new Date(), 1)
    return format(future, 'yyyy-MM-dd')
  },
  // this logic isn't exactly the same as backend - their date comparisons are UTC and likely coerce the date comparison
  // to be dates (ignoring time), inclusive of start/end date. Approximate is good enough for our tests.
  status() {
    const now = new Date()
    const start = new Date(this.startDate)
    const end = new Date(this.endDate)
    if (isAfter(now, end)) return 'expired'
    if (isAfter(now, start)) return 'active'
    return 'pending'
  },
  isTrial: false,
})
